import querystring from 'querystring';
import api from '../api';

class DataServiceLessonsContent {
  addLessonContent(data) {
    return api.post('lesson-contents', data);
  }

  getLessonContent(params) {
    const url = 'lesson-contents?' + querystring.stringify(params);
    return api.get(url);
  }

  getLessonContentById(id) {
    return api.get(`lesson-contents/${id}`);
  }

  updateLessonContent(id, data) {
    return api.put(`lesson-contents/${id}`, data);
  }

  deleteLessonContent(id) {
    return api.delete(`lesson-contents/${id}`);
  }

  // Lesson Content Exams
  getCourseExamsWithScore(id_user, id_company_course) {
    return api.get(
      `/lesson-content-exams/student/${id_user}/course/${id_company_course}`
    );
  }

  // Lesson Content Exams Attempts
  checkNewExamAttempt(id_user, id_lesson_content, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.get(
      `/lesson-content-exams-attempts/student/${id_user}/lesson-content/${id_lesson_content}/check-retry${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

  releaseNewExamAttempt(id_user, id_lesson_content, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.post(
      `/lesson-content-exams-attempts/student/${id_user}/lesson-content/${id_lesson_content}/new-attempt${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

  releaseFinishedExamAttempt(id_user, id_lesson_content) {
    return api.post(
      `/lesson-content-exams-attempts/student/${id_user}/lesson-content/${id_lesson_content}/finished-attempt`
    );
  }

  getCourseExams(id_company_course, id_user, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.get(
      `/finish-lesson-content-exams/course/${id_company_course}/user/${id_user}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }  

  releaseFinishedExam(id_user, id_lesson_content, id_course, score, query = {}){
    const queryParams = querystring.stringify(query);
    return api.post(
      `finish-lesson-content-exams/student/${id_user}/lesson-content/${id_lesson_content}/course/${id_course}/score/${score}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

  releaseFinishedCourse(id_user, id_company_course, query = {}){
    const queryParams = querystring.stringify(query);
    return api.post(
      `finish-lesson-content-course/student/${id_user}/course/${id_company_course}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

}

export default new DataServiceLessonsContent();
